import API from './api';

export const shareDriveService = {
  // List items inside a folder (parent_id=null means root)
  getItems: (parentId = null) =>
    API.get('/share-drive', { params: parentId ? { parent_id: parentId } : {} }),

  // Create a new folder
  createFolder: (name, parentId = null) =>
    API.post('/share-drive/folder', { name, parent_id: parentId }),

  // Upload a file
  uploadFile: (file, parentId = null, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    if (parentId) formData.append('parent_id', parentId);
    return API.post('/share-drive/upload', formData, {
      onUploadProgress: onProgress
        ? (e) => onProgress(Math.round((e.loaded * 100) / e.total))
        : undefined,
    });
  },

  // Download a file (returns blob)
  downloadFile: (id) =>
    API.get(`/share-drive/download/${id}`, { responseType: 'blob' }),

  // Delete an item
  deleteItem: (id) => API.delete(`/share-drive/${id}`),

  // Share an item with another user
  shareItem: (id, targetUserId, accessType) =>
    API.post(`/share-drive/${id}/share`, {
      target_user_id: targetUserId,
      access_type: accessType,
    }),

  // Revoke access
  revokeAccess: (id, targetUserId) =>
    API.delete(`/share-drive/${id}/share/${targetUserId}`),

  // Get share list for an item
  getItemShares: (id) => API.get(`/share-drive/${id}/shares`),

  // Get breadcrumb path
  getBreadcrumb: (id) => API.get(`/share-drive/${id}/breadcrumb`),

  // Get all users for share dialog
  getUsers: () => API.get('/share-drive/users'),

  // Preview a file inline (blob)
  previewFile: (id) =>
    API.get(`/share-drive/preview/${id}`, { responseType: 'blob' }),
};
